import PaymentAddress from './PaymentAddress';

export default PaymentAddress;
